// extracted by mini-css-extract-plugin
module.exports = {"bookWrapper":"_2cERkA5Xn9R80VcoeTFegF _3Y7xEtrTgaC28IokfnEvTA"};